import { CalendarDays, ExternalLink, Flame, Hash, Radio } from "lucide-react";
import { useParams } from "react-router-dom";
import { useTrack } from "../api";
import { Appearances } from "../components/Appearances";
import { ArtistLinks } from "../components/ArtistLinks";
import { Cover } from "../components/Cover";
import { PositionChart } from "../components/PositionChart";
import { ErrorBox, Loading } from "../components/State";
import {
  artistNames,
  listenUrl,
  longDate,
  yearRange,
} from "../format";
import { useTitle } from "../hooks";

export function Track() {
  const { id = "" } = useParams();
  const { data, isLoading, error } = useTrack(id);
  useTitle(
    data
      ? `${data.title} – ${artistNames(data.artists, data.credit)}`
      : undefined,
  );

  if (isLoading) return <Loading />;
  if (error || !data) return <ErrorBox error={error} />;
  const s = data.stats;

  return (
    <article>
      <header className="track-head">
        <Cover url={data.imageUrl} id={data.id} title={data.title} size={140} play={data} />
        <div>
          <p className="kicker">Utwór</p>
          <h1>{data.title}</h1>
          <p className="track-head__artists">
            <ArtistLinks artists={data.artists} fallback={data.credit} />
          </p>
          <a
            className="btn"
            href={listenUrl(data.artists, data.title, data.credit)}
            target="_blank"
            rel="noreferrer noopener"
          >
            <ExternalLink size={17} aria-hidden="true" /> Posłuchaj na YouTube
          </a>
        </div>
      </header>

      {s && (
        <dl className="stats">
          <div>
            <dt><Radio size={14} aria-hidden="true" /> Na listach</dt>
            <dd>{yearRange(s.firstDate, s.lastDate)}</dd>
          </div>
          <div>
            <dt><Hash size={14} aria-hidden="true" /> Notowań</dt>
            <dd>{s.entries}</dd>
          </div>
          <div>
            <dt><Flame size={14} aria-hidden="true" /> Najwyżej</dt>
            <dd>#{s.bestPosition}</dd>
          </div>
          <div>
            <dt><CalendarDays size={14} aria-hidden="true" /> Ostatnio</dt>
            <dd>{longDate(s.lastDate)}</dd>
          </div>
        </dl>
      )}

      <h2>Przebieg na listach</h2>
      <PositionChart history={data.history} charts={data.charts} trackId={data.id} />

      <h2>Gdzie grano</h2>
      <Appearances history={data.history} charts={data.charts} trackId={data.id} />
    </article>
  );
}
